<template>
  <b-modal
    ref="addWidgetModal"
    hide-footer
    centered
    title="Create new widget"
    size="lg"
    @shown="modalShown"
    @hidden="modalHidden"
    no-close-on-backdrop
    no-close-on-esc
    >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Title:"
        >
        <b-form-input
          type="text"
          v-model.trim="title"
          />
      </b-form-group>
      <div class="gridstackSize">
        <div class="gridstackSize__item">
          <b-form-group
            label="Gridstack width:"
            >
            <b-form-input
              v-model="gridstackWidth"
              type="number"
              min="1"
              max="24"
              @change="adjustGridstackWidth"
              />
          </b-form-group>
        </div>
        <div class="gridstackSize__item">
          <b-form-group
            label="Gridstack height:"
            >
            <b-form-input
              v-model="gridstackHeight"
              type="number"
              min="1"
              max="40"
              @change="adjustGridstackHeight"
              />
          </b-form-group>
        </div>
      </div>
      <b-form-group
        label="Classes:"
        >
        <b-form-input
          type="text"
          v-model.trim="classes"
          />
      </b-form-group>
      <b-form-group
        label="Template code:"
        >
        <div class="templateEditor">
          <codemirror
            v-if="shown"
            :value="code"
            :options="cmOptions"
            @input="onCmCodeChange"
            @keydown.ctrl.83.native.prevent="save"
            />
        </div>
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

let $ = window.$

export default {
  data () {
    return {
      shown: false,
      title: '',
      gridstackWidth: 12,
      gridstackHeight: 8,
      classes: '',
      code: '',
      cmOptions: {
        tabSize: 2,
        styleActiveLine: false,
        lineNumbers: true,
        styleSelectedText: false,
        line: true,
        foldGutter: true,
        gutters: [
          'CodeMirror-linenumbers',
          'CodeMirror-foldgutter'
        ],
        highlightSelectionMatches: {
          showToken: /\w/,
          annotateScrollbar: true
        },
        hintOptions: {
          completeSingle: false
        },
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        extraKeys: {
          'Ctrl': 'autocomplete'
        },
        mode: 'text/x-vue'
      }
    }
  },
  computed: {
    ...mapState([
      'currentTab'
    ])
  },
  methods: {
    modalShown () {
      this.shown = true
    },
    modalHidden () {
      this.shown = false
    },
    onCmCodeChange (code) {
      this.code = code
    },
    save () {
      let vm = this
      let data = {
        title: vm.title,
        w: vm.gridstackWidth,
        h: vm.gridstackHeight,
        classes: vm.classes,
        template: vm.code,
        tab: vm.currentTab
      }

      this.$store.commit('addProcess', {
        process: 'addWidget',
        message: 'Creating'
      })

      db.widgets.create(data, (key) => {
        if (this.$refs.addWidgetModal) this.$refs.addWidgetModal.hide()
        this.code = ''
        this.title = ''
        this.gridstackWidth = 12
        this.gridstackHeight = 8
        this.$store.commit('deleteProcess', 'addWidget')
        this.$store.commit('editWidget', {
          key,
          insert: true
        })
      })
    },
    adjustGridstackWidth () {
      if (!+this.gridstackWidth) this.gridstackWidth = 1
      if (+this.gridstackWidth < 0) {
        this.gridstackWidth = 1
      }
      if (+this.gridstackWidth > 24) {
        this.gridstackWidth = 24
      }
    },
    adjustGridstackHeight () {
      if (!+this.gridstackHeight) this.gridstackHeight = 1
      if (+this.gridstackHeight < 0) {
        this.gridstackHeight = 1
      }
      if (+this.gridstackHeight > 40) {
        this.gridstackHeight = 40
      }
    }
  },
  created () {
    eventBus.$on('showAddWidgetModal', () => {
      if (this.$refs.addWidgetModal) this.$refs.addWidgetModal.show()
    })
  },
  mounted () {
    if (this.$refs.addWidgetModal) {
      $(this.$refs.addWidgetModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.addWidgetModal) {
      $(this.$refs.addWidgetModal['$el']).remove()
    }
  }
}
</script>

<style lang="scss">
@import '~$scss/globals';

.templateEditor {
  height: 40vh;
  border: 1px solid $borderColor1;
}
.vue-codemirror {
  height: 100%;
}
.CodeMirror {
  height: 100%;
}
.gridstackSize {
  @include cf;
  &__item {
    @include span(6)
    &:first-child {
      padding-right: 10px;
    }
    &:last-child {
      padding-left: 20px;
    }
    @include breakpoint(max-width $screenSm) {
      @include span(12)
      &:first-child {
        padding-right: 0;
      }
      &:last-child {
        padding-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/AddWidget.vue